module.exports = __webpack_public_path__ + "static/media/Montserrat-SemiBold_72e0d276db1e5baa6f2b4caddfef5b93.c88cecbf.ttf";